import { FC } from "react";

import { SpinnerIcon, TargetIcon } from "@/assets/icons";

import { twMerge } from "tailwind-merge";

import MapMenuItemControl from "../menuItemControl";

type Props = {
  onLocate: () => void;
  /** A fix is in flight — the browser may still be showing its own prompt. */
  isLocating?: boolean;
  /** Permission is denied; only the browser's site settings can lift it. */
  isBlocked?: boolean;
  className?: string;
};

const MapUserLocationControl: FC<Props> = ({
  onLocate,
  isLocating = false,
  isBlocked = false,
  className
}) => (
  <MapMenuItemControl
    className={twMerge(
      "rounded-lg border-[1px] border-gainsboro",
      isBlocked && "opacity-50",
      className
    )}
    // Stays clickable while blocked to show the toast that explains the cause of the block.
    onClick={isLocating ? undefined : onLocate}
    aria-label="Show My Location"
    aria-busy={isLocating}
    tooltipContent={
      isBlocked
        ? "Location access is blocked."
        : "Center the map on my location."
    }
  >
    {isLocating ? (
      <SpinnerIcon className="w-4 h-4 animate-spin" />
    ) : (
      <TargetIcon className="w-6 h-6 cursor-pointer" />
    )}
  </MapMenuItemControl>
);

export default MapUserLocationControl;
